export function getCookie(name: string): string | null {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

export function parseCookieValue(cookieValue: string): { [key: string]: string } {
  const keyValuePairs = cookieValue.split('&');
  const result: { [key: string]: string } = {};

  keyValuePairs.forEach(pair => {
    const [key, value] = pair.split('=');
    if (key && value) {
      result[key] = decodeURIComponent(value);
    }
  });

  return result;
}

function setCookie(name: string, value: string) {
  document.cookie = `${name}=${value || ""}; path=/`;
}


export function setCookieFromQueryString(name: string, prefix: string) {
  const urlParams = new URLSearchParams(window.location.search);
  const params: Record<string, string> = {};
  if (!urlParams)
    return;

  urlParams?.forEach((value, key) => {
    if (key.startsWith(prefix)) {
      params[key] = value;
    }
  });

  const utmParamsString = new URLSearchParams(params).toString();
  setCookie(name, utmParamsString || "");
}

export function proccessCookie(name: string, allowed: string[] = null): { [key: string]: string } {
  const params = getCookie(name);
  if (params) {
    const parsedParams = parseCookieValue(params);
    if (allowed) {
      return filterParams(parsedParams, allowed);
    }
    return parsedParams;
  }
  return null;
}

export function filterParams(params: { [key: string]: string }, allowed: string[]): { [key: string]: string } {
  const filteredParams: { [key: string]: string } = {};
  for (const key in params) {
    if (allowed.includes(key)) {
      filteredParams[key] = params[key];
    }
  }
  return filteredParams;
}
